module.exports = __webpack_public_path__ + "static/img/checkbox.f12dcf82.svg";